export default __webpack_public_path__ + "static/media/down.a289f8fe.svg";